var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.logs.length)?_c('section',{attrs:{"id":"installation-report-upgrades"}},[_c('h5',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.translate("Server Upgrades")))]),_c('chart',_vm._b({},'chart',_vm.chart_config,false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }